import { render } from "./CatalogElement.vue?vue&type=template&id=2a40690b&scoped=true"
import script from "./CatalogElement.vue?vue&type=script&lang=js"
export * from "./CatalogElement.vue?vue&type=script&lang=js"

import "./CatalogElement.vue?vue&type=style&index=0&id=2a40690b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a40690b"]])

export default __exports__